import { reader } from './reader';

// ----------------------------------------------------------------------------

export type TypeToBase64Config = {
    fnSuccess?: (data: any) => void;
    fnError?: (evt: ProgressEvent<FileReader>) => void;
};

// ----------------------------------------------------------------------------

async function toBase64(file: File, config: TypeToBase64Config): Promise<any> {
    return reader(file, {
        readType: 'readAsDataURL',
        fnSuccess: function (data): any {
            // If using function success
            if (typeof config.fnSuccess === 'function') {
                config.fnSuccess(data);
            }
        },
        fnError: function (evt): any {
            // If using function error
            if (typeof config.fnError === 'function') {
                config.fnError(evt);
            }
        },
    });
}

// ----------------------------------------------------------------------------

export default toBase64;
